import { ArrowBack } from '@mui/icons-material';
import { Breadcrumbs, IconButton, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

import s from './PageNav.module.scss';

type Props = {
  /** Раздел-каталог: «Очереди», «Доски» */
  parent: { label: string; to: string };
  current: string;
};

/**
 * Назад и хлебные крошки над страницей сущности. Назад — всегда в каталог: история может вести
 * в карточку задачи или за пределы приложения
 */
const PageNav: React.FC<Props> = ({ parent, current }) => (
  <div className={s.nav}>
    <IconButton component={Link} to={parent.to} size="small" aria-label={`Назад: ${parent.label}`}>
      <ArrowBack fontSize="small" />
    </IconButton>
    <Breadcrumbs sx={{ fontSize: 14 }}>
      <Link to={parent.to} className={s.nav__crumb}>
        {parent.label}
      </Link>
      <Typography fontSize="inherit" color="text.primary">
        {current}
      </Typography>
    </Breadcrumbs>
  </div>
);

export { PageNav };
